// Resolves the venue object passed to PDF exporters by merging the
// tournament-level venue (which may carry `logo_path`, `name`, courts info)
// with the user-level "Info Circolo" record (which carries the full address,
// email, maps link and extra logos).
import { api } from "@/lib/api";

let userVenuePromise = null;

export function getUserVenueCached() {
  if (!userVenuePromise) {
    userVenuePromise = api.get("/venue").catch(() => null);
  }
  return userVenuePromise;
}

export function invalidateUserVenueCache() {
  userVenuePromise = null;
}

export async function buildPdfVenue(tournamentVenue) {
  const user = (await getUserVenueCached()) || {};
  // Prefer tournament-level data for `logo_path`, `name` and `phone`/`google_maps_link`,
  // but fall back to the user venue otherwise. Always carry the user's full
  // address fields and extra_logos because tournament venues don't have them.
  return {
    ...user,
    name: tournamentVenue?.name || user.name || "",
    phone: tournamentVenue?.phone || user.phone || "",
    address: tournamentVenue?.address || user.address || "",
    google_maps_link: tournamentVenue?.google_maps_link || user.maps_link || "",
    maps_link: user.maps_link || tournamentVenue?.google_maps_link || "",
    logo_path: tournamentVenue?.logo_path || "",
    logo_url: user.logo_url || "",
    city: user.city || "",
    province: user.province || "",
    zip: user.zip || "",
    email: user.email || "",
    extra_logos: Array.isArray(user.extra_logos) ? user.extra_logos : [],
  };
}
